import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

export function useHoneyBalance() {
  return useQuery({
    queryKey: ["/api/honey/balance"],
    queryFn: async () => {
      const res = await fetch("/api/honey/balance");
      if (!res.ok) throw new Error("Failed to fetch balance");
      const data = await res.json();
      return data.balance as number;
    },
  });
}

export function useHoneyHistory() {
  return useQuery({
    queryKey: ["/api/honey/history"],
    queryFn: async () => {
      const res = await fetch("/api/honey/history");
      if (!res.ok) throw new Error("Failed to fetch history");
      return res.json();
    },
  });
}

export function useVenueSpecials(venueId: number) {
  return useQuery({
    queryKey: ["/api/venues", venueId, "specials"],
    queryFn: async () => {
      const res = await fetch(`/api/venues/${venueId}/specials`);
      if (!res.ok) throw new Error("Failed to fetch specials");
      return res.json();
    },
    enabled: !!venueId,
  });
}

export function useRedeemSpecial() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (specialId: number) => {
      const res = await fetch(`/api/specials/${specialId}/redeem`, { method: "POST" });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message);
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/honey/balance"] });
      queryClient.invalidateQueries({ queryKey: ["/api/honey/history"] });
    },
  });
}

export function useBusinessSpecials() {
  return useQuery({
    queryKey: ["/api/business/specials"],
    queryFn: async () => {
      const res = await fetch("/api/business/specials");
      if (!res.ok) throw new Error("Failed to fetch specials");
      return res.json();
    },
  });
}
